import React from "react";
import { CheckCircle2, AlertTriangle, XCircle } from "lucide-react";
import { cn } from "../lib/utils";

const statusConfig = {
  em_dia: {
    label: "Em dia",
    className: "bg-emerald-100 text-emerald-800 border-emerald-200",
    icon: CheckCircle2,
  },
  vencendo: {
    label: "Vencendo",
    className: "bg-amber-100 text-amber-800 border-amber-200",
    icon: AlertTriangle,
  },
  vencido: {
    label: "Vencido",
    className: "bg-red-100 text-red-800 border-red-200",
    icon: XCircle,
  },
};

export const StatusBadge = ({ status, showIcon = true, className }) => {
  const config = statusConfig[status] || statusConfig.em_dia;
  const Icon = config.icon;

  return (
    <span
      data-testid={`status-badge-${status}`}
      className={cn(
        "inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold border",
        config.className,
        className
      )}
    >
      {showIcon && <Icon className="w-3.5 h-3.5" />}
      {config.label}
    </span>
  );
};

export default StatusBadge;
